import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrentUserBoxComponent } from './current-user-box.component';
import { SharedModule } from '@app/shared/shared.module';
import { CpfPipe } from '@app/shared/pipes/cpf.pipe';

@NgModule({
  declarations: [CurrentUserBoxComponent],
  imports: [CommonModule, SharedModule],
  exports: [CurrentUserBoxComponent],
  providers: [CpfPipe],
})
export class CurrentUserBoxModule {}
